import React from 'react';
import styled from 'styled-components';

export const STEPS = [
  { id: 1, label: '그룹 선택' },
  { id: 2, label: '개발환경 선택' },
  { id: 3, label: '기능 선택' },
  { id: 4, label: '견적 확인' },
];

const StepperWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 18px 24px;
  background: ${p => p.theme.bgCard};
  border-bottom: 1px solid ${p => p.theme.border};
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  @media screen and (max-width: 768px) {
    gap: 4px;
    padding: 12px 10px;
  }
`;

const StepItem = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border: 1px solid ${p => p.$active ? p.theme.accent : 'transparent'};
  background: ${p => p.$active ? p.theme.accentLight : 'transparent'};
  border-radius: 999px;
  cursor: pointer;
  transition: ${p => p.theme.transition};
  color: ${p => p.$active ? p.theme.accent : p.$completed ? p.theme.text : p.theme.textMuted};
  font-weight: ${p => p.$active ? 700 : 500};
  font-size: 14px;
  flex-shrink: 0;

  &:hover {
    background: ${p => p.$active ? p.theme.accentLight : p.theme.bgHover};
  }

  @media screen and (max-width: 768px) {
    padding: 6px 10px;
    font-size: 12px;
    gap: 6px;
  }
  @media screen and (max-width: 380px) {
    padding: 5px 8px;
    font-size: 11px;
    gap: 4px;
  }
`;

const StepCircle = styled.span`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  background: ${p => p.$active ? p.theme.accent : p.$completed ? p.theme.accent : p.theme.bgTag};
  color: ${p => (p.$active || p.$completed) ? '#fff' : p.theme.textMuted};
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    width: 20px;
    height: 20px;
    font-size: 11px;
  }
`;

const StepDivider = styled.div`
  flex: 0 0 32px;
  height: 1px;
  background: ${p => p.$completed ? p.theme.accent : p.theme.border};

  @media screen and (max-width: 768px) {
    flex: 0 0 8px;
  }
`;

export default function Stepper({ current, onChange }) {
  return (
    <StepperWrap>
      {STEPS.map((step, idx) => {
        const active = current === step.id;
        const completed = current > step.id;
        return (
          <React.Fragment key={step.id}>
            <StepItem
              type="button"
              $active={active}
              $completed={completed}
              onClick={() => onChange?.(step.id)}
            >
              <StepCircle $active={active} $completed={completed}>
                {step.id}
              </StepCircle>
              {step.label}
            </StepItem>
            {idx < STEPS.length - 1 && <StepDivider $completed={current > step.id} />}
          </React.Fragment>
        );
      })}
    </StepperWrap>
  );
}
